export default __webpack_public_path__ + "static/media/LC feedback.abbae3ca.svg";